var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('img',{attrs:{"src":require("./assets/uu.png")}}),_c('HelloWorld',{attrs:{"msg":"1198219 B.C. LTD. -- Coming Soon."}}),_c('CookieNotice',{attrs:{"cookieName":"mytest"}},[_vm._v(" This is the Cookie Notice. We use Cookies on this website. Click if you agree ->>  ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }